import { render } from "./UserPermissions.vue?vue&type=template&id=06fadb90"
import script from "./UserPermissions.vue?vue&type=script&lang=js"
export * from "./UserPermissions.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__